import { render, staticRenderFns } from "./uploadRecords.vue?vue&type=template&id=4a10a346&scoped=true&"
import script from "./uploadRecords.vue?vue&type=script&lang=js&"
export * from "./uploadRecords.vue?vue&type=script&lang=js&"
import style0 from "./uploadRecords.vue?vue&type=style&index=0&id=4a10a346&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a10a346",
  null
  
)

export default component.exports